<template>
  <div :class="countBoxClasses">
    <sx-tiny color="currentcolor">{{ count }}<span>/</span>{{ total }}</sx-tiny>
    <div class="countBox__indicator" :style="`width: ${width}%`" />
  </div>
</template>

<script>
import SxTiny from './SxTiny';

export default {
  components: {
    SxTiny,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    countBoxClasses() {
      const dClasses = new Set(['countBox']);
      const isEqual = this.count === this.total;

      // Handle states
      if (this.total > 0 && this.count > 0 && isEqual)
        dClasses.add('countBox--completed');
      else if (this.count === 0 && !isEqual) dClasses.add('countBox--empty');
      else if (this.total === 0) dClasses.add('countBox--na');

      // Disabled
      if (this.isDisabled) dClasses.add('countBox--disabled');

      return [...dClasses].join(' ');
    },
    width() {
      const steps = this.total || 1;
      const count = this.count || 1;
      const percentageComplete = Math.round((count / steps) * 100);

      return percentageComplete;
    },
  },
};
</script>

<style scoped>
.countBox {
  position: relative;

  display: inline-flex;
  justify-content: center;
  gap: 4px;
  flex-direction: column;
  height: 24px;
  overflow: hidden;

  background-color: var(--gray-0);
  box-shadow: inset 0 -2px 0 var(--blue-100);
  border: 1px solid var(--blue-200);
  border-radius: 4px;
  color: var(--blue-600);
}

.countBox small {
  padding: 0 6px;

  line-height: 24px;
  white-space: nowrap;
}

.countBox small span {
  margin-inline: 3px;
  color: currentcolor;
}

.countBox__indicator {
  position: absolute;
  bottom: 0;

  display: block;
  height: 2px;

  background-color: var(--blue-200);
}

.countBox--completed {
  background-color: var(--green-100);
  box-shadow: inset 0 -2px 0 var(--green-100);
  border-color: var(--green-200);
  color: var(--green-600);
}

.countBox--disabled,
.countBox--na {
  background-color: var(--gray-0);
  box-shadow: inset 0 -2px 0 var(--gray-0);
  border-color: var(--gray-100);
  color: var(--gray-500);
}

.countBox--completed .countBox__indicator,
.countBox--na .countBox__indicator,
.countBox--empty .countBox__indicator {
  display: none;
}
</style>
